// for version < 2.8.0
// export const FROALA_LICENSE_KEY = 'VZSZGUSXYSMZe1JGZ==';
// for versions >= 2.8
// export const FROALA_LICENSE_KEY = 'VA5D6C5C5eC3I3C7B7C4C4C3A3C2H2xJCJWECHICc2JOZWJ==';
// for versions > 3.0.0
// export const FROALA_LICENSE_KEY = '9KH3cA3A4D4A1xROKLJKYHROLDXDRE1b1YYGRi1Bd1C4F4B3H3G3A15A15A12C5C4==';
// for versions >= 4
export const FROALA_LICENSE_KEY = 'QFF4nB14B7B8E6A5A3eMRPYa1c1REe1BGQOQIc1CDBREJImD6F5F4H4E1B9A6C3C4A3==';
